import React from 'react';
import { gpGetConversationsList, gpGetMyMessages, gpGetAllPatientMessages } from 'api/group';
import { TConversation, TGPScope } from 'types/inbox';

const useGPConversations = (
    size?: number,
    scope?: TGPScope,
): [TConversation[] | undefined, boolean, (size?: number) => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TConversation[]>();

    const fetchData = async (_size?: number) => {
        try {
            loading.current = true;
            const fetchSize = _size || size || 50;
            let result;
            if (scope === 'all') {
                result = await gpGetAllPatientMessages(1, fetchSize);
            } else {
                result = await gpGetMyMessages(1, fetchSize);
            }
            if (!result.error) {
                const data: TConversation[] = result?.data?.data?.records || result?.data?.data || [];
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };

    React.useEffect(() => {
        if (!loading.current) {
            fetchData(size);
        }
    }, [size, scope]);

    return [items, loading.current, fetchData];
};

export default useGPConversations;
